export default __webpack_public_path__ + "static/media/keineHintergruende.352f275e.png";